import Contentful from './contentful';

const CONTENTFUL_CONTENT_TYPE = 'legal';

function Legal() {
  Contentful.call(this);
}

Legal.prototype = Object.create(Contentful.prototype, {
  contentType: {
    value: CONTENTFUL_CONTENT_TYPE,
  },
});

Legal.prototype.constructor = Legal;

Legal.prototype.get = async function get() {
  return (await this.entries()).filterLatest().filterFields().data();
};

export default Legal;
